import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiRequest from '../../api/request';

const initialState = {
  studentSessionAnalyticsTable: {
    loading: false,
    data: [],
    meta: {},
  },
  inactiveStudentDataAnalytcsTable: {
    loading: false,
    data: [],
    meta: {},
  },
  tcUploadStudentDetailsTable: {
    loading: false,
    data: [],
    meta: {},
  },
  tpVerificationTable: {
    loading: false,
    data: [],
    meta: {},
  },
  courseIncomeTable: {
    loading: false,
    data: [],
    meta: {},
  },
  croIndividualAccountsTable: {
    loading: false,
    data: [],
    meta: {},
  },
  expiringAdmissionTable: {
    loading: false,
    data: [],
    meta: {},
  },

  departmentEmployeesTable: {
    loading: false,
    data: [],
    meta: {},
  },
  studentClassRestartDateTable: {
    loading: false,
    data: [],
    meta: {},
  },
  croPerfomanceAnalyticsTable: {
    loading: false,
    data: [],
    meta: {},
  },
  croAnalyticsTable: {
    data: [],
    loading: false,
    meta: {},
  },
  coursePerfomanceAnalyticsTable: {
    data: [],
    loading: false,
    meta: {},
  },
  trainerMOUTable: {
    data: [],
    loading: false,
    meta: {},
  },
  paymentMethods: [],
  allTrainers: {
    data: [],
    loading: false,
  },
  loading: false,
  submitLoading: false,
  dailyNoAttendanceStudentsTable: {
    loading: false,
    data: [],
    meta: {},
  },
  emiPaymentsTable: {
    loading: false,
    data: [],
    meta: {},
  },
  tutorReplacementsTable: {
    loading: false,
    data: [],
    meta: {},
  },
  monthlyAccounts: {
    loading: false,
    data: [],
    summary: 0,
  },
  attendanceViewTable: {
    loading: false,
    data: [],
  },
  attendanceSingleViewTable: {
    loading: false,
    data: [],
  },
  nonScheduleVerificationTable: {
    loading: false,
    data: [],
  },
  reportingUnderHead: {
    loading: false,
    data: [],
  },
};
// ======================THUNKS-----========================================

export const getStudentSessionAnalyticsTable = createAsyncThunk(
  'crdMigration/getStudentSessionAnalyticsTable',
  async (params) => {
    const searchParams = new URLSearchParams(params);
    const res = await apiRequest({
      method: 'get',
      url: `crd-migrations/get-student-session-analytics?${searchParams.toString()}`,
    });
    return res;
  },
);

export const getInactiveStudentDataAnalytcsTable = createAsyncThunk(
  'crdMigration/getInactiveStudentDataAnalytcsTable',
  async (params) => {
    const searchParams = new URLSearchParams(params);
    const res = await apiRequest({
      method: 'get',
      url: `analytics/croInactiveStudentsAnalytics?${searchParams.toString()}`,
    });
    return res;
  },
);

export const getTCUploadStudentDetailsTable = createAsyncThunk(
  'crdMigration/getTCUploadStudentDetailsTable',
  async (params) => {
    const searchParams = new URLSearchParams(params);
    const res = await apiRequest({
      method: 'get',
      url: `crd-migrations/get-tc-uploaded-student-details?${searchParams.toString()}`,
    });
    return res;
  },
);

export const getTpVerificationTable = createAsyncThunk('crdMigration/getTpVerificationTable', async (params) => {
  const searchParams = new URLSearchParams(params);
  const res = await apiRequest({
    method: 'get',
    url: `impact-report/get-student-performance-data?${searchParams.toString()}`,
  });
  return res;
});

export const getCourseIncomeTable = createAsyncThunk('crdMigration/getCourseIncomeTable', async (params) => {
  const searchParams = new URLSearchParams(params);
  const res = await apiRequest({
    method: 'get',
    url: `crd-migrations/get-course-incomes?${searchParams.toString()}`,
  });
  return res;
});

export const getCroIndividualAccountsTable = createAsyncThunk(
  'crdMigration/getCroIndividualAccountsTable',
  async (params) => {
    const searchParams = new URLSearchParams(params);
    const res = await apiRequest({
      method: 'get',
      url: `crd-migrations/get-cro-indivitual-accounts?${searchParams.toString()}`,
    });
    return res;
  },
);

export const getExpiringAdmissionTable = createAsyncThunk(
  'crdMigration/getExpiringAdmission',
  async (params, { signal }) => {
    const searchParams = new URLSearchParams(params);
    const res = await apiRequest({
      method: 'get',
      url: `analytics/getExpiringAdmissions?${searchParams.toString()}`,
      signal,
    });
    return res;
  },
);

// export const getDepartmentEmployeesTable = createAsyncThunk(
//   'crdMigration/getDepartmentEmployeesTable',
//   async (params) => {
//     const searchParams = new URLSearchParams(params);
//     const res = await apiRequest({
//       method: 'get',
//       url: `impact-report/get-student-performance-data?${searchParams.toString()}`,
//     });
//     return res;
//   },
// );

export const getDepartmentEmployeesTable = createAsyncThunk(
  'crdMigration/getDepartmentEmployeesTable',
  async (params) => {
    const { page, limit, search, filters, departmentName } = params;

    const searchParams = new URLSearchParams({
      page,
      limit,
      search,
    });

    const res = await apiRequest({
      method: 'get',
      url: `users/all-users/?page=${page}&limit=${limit}&search=${search}&filters[department]=equals:${departmentName}`,
    });

    return res;
  },
);

export const getStudentClassRestartDateTable = createAsyncThunk(
  'crdMigration/getStudentClassRestartDateTable',
  async (params) => {
    const searchParams = new URLSearchParams(params);
    const res = await apiRequest({
      method: 'get',
      url: `crd-migrations/get-student-restart-dates?${searchParams.toString()}`,
    });
    return res;
  },
);

export const getCroPerfomanceAnalytics = createAsyncThunk('crdMigration/getCroPerfomanceAnalytics', async (params) => {
  const searchParams = new URLSearchParams(params);
  const res = await apiRequest({
    method: 'get',
    url: `analytics/croPerformanceAnalytics?${searchParams.toString()}`,
  });
  return res;
});

export const getCroAnalyticsTable = createAsyncThunk('crdMigration/getCroAnalyticsTable', async (params) => {
  const searchParams = new URLSearchParams(params);
  const res = await apiRequest({
    method: 'get',
    url: `crd-migrations/get-cro-analytics?${searchParams.toString()}`,
  });
  return res;
});

export const getCoursePerfomanceAnalytics = createAsyncThunk(
  'crdMigration/getCoursePerfomanceAnalytics',
  async (params) => {
    const searchParams = new URLSearchParams(params);
    const res = await apiRequest({
      method: 'get',
      url: `analytics/getCoursePerformance?${searchParams.toString()}`,
    });
    return res;
  },
);

export const getPaymentMethods = createAsyncThunk('crdMigration/getPaymentMethods', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `crd-migrations/get-payment-methods`,
  });
  return res;
});

export const getTrainerMOUTable = createAsyncThunk('crdMigration/getTrainerMOUTable', async (params) => {
  const searchParams = new URLSearchParams(params);
  const res = await apiRequest({
    method: 'get',
    url: `crd-migrations/get-trainer-mou-details?${searchParams}`,
  });
  return res;
});

export const putTrainerMOUDetails = createAsyncThunk('crdMigration/putTrainerMOUDetails', async ({ data, id }) => {
  const res = await apiRequest({
    method: 'put',
    url: `crd-migrations/update-trainer-mou-details?trainer_mou_id=${id}`,
    data,
  });
  return res;
});
export const getTrainerWithSearch = createAsyncThunk('crdMigration/getTrainerWithSearch', async (search = null) => {
  const res = await apiRequest({
    method: 'get',
    url: `crd-migrations/get-trainer-list?search=${search}`,
  });
  return res;
});

export const postTrainerMOUDetails = createAsyncThunk('crdMigration/postTrainerMOUDetails', async (data) => {
  const res = await apiRequest({
    method: 'post',
    url: `crd-migrations/create-trainer-mou-details`,
    data,
  });
  return res;
});

export const getDailyNoAttendanceStudents = createAsyncThunk(
  'crdMigration/getDailyNoAttendanceStudents',
  async (params) => {
    const searchParams = new URLSearchParams(params);
    const res = await apiRequest({
      method: 'get',
      url: `crd-migrations/get-daily-not-marked-attendance?${searchParams}`,
    });
    return res;
  },
);

export const getEmiPayments = createAsyncThunk('crdMigration/getEmiPayments', async (params) => {
  const searchParams = new URLSearchParams(params);
  const res = await apiRequest({
    method: 'get',
    url: `/crd-migrations/get-emi-payments?${searchParams}`, // ✅ FIXED: correct endpoint
  });
  return res;
});

// Tutor Replacements: the table and its CSV export read the same endpoint.
// `signal` lets an aborted thunk cancel the HTTP request too, not just ignore its response.
const fetchTutorReplacements = (params, signal) =>
  apiRequest({
    method: 'get',
    url: `analytics/tutorReplacementStats/replacements?${new URLSearchParams(params)}`,
    signal,
  });

export const getTutorReplacements = createAsyncThunk('crdMigration/getTutorReplacements', (params, { signal }) =>
  fetchTutorReplacements(params, signal),
);

// no reducers, so exporting never replaces the rows on screen
export const exportTutorReplacements = createAsyncThunk('crdMigration/exportTutorReplacements', (params) =>
  fetchTutorReplacements(params),
);

// project dropdown for Tutor Replacements: all projects plus the logged in user's own project to preselect
export const getTutorReplacementProjects = createAsyncThunk('crdMigration/getTutorReplacementProjects', (_, { signal }) =>
  apiRequest({ method: 'get', url: `analytics/tutorReplacementStats/projects`, signal }),
);

export const getMonthlyAccounts = createAsyncThunk('crdMigration/getMonthlyAccounts', async (params) => {
  const searchParams = new URLSearchParams(params);
  const res = await apiRequest({
    method: 'get',
    url: `analytics/getMonthlyAccounts?${searchParams.toString()}`,
  });
  return res;
});

export const getAttendanceView = createAsyncThunk('crdMigration/getAttendanceView', async (params) => {
  const res = await apiRequest({
    method: 'get',
    url: `analytics/getAttendanceMatrix/${params?.year}/${params?.month}`,
  });
  return res;
});

export const fetchAttendanceData = createAsyncThunk('crdMigration/fetchAttendanceData', async (params) => {
  const searchParams = new URLSearchParams(params);
  const res = await apiRequest({
    method: 'get',
    url: `analytics/fetchAttendanceData?${searchParams}`,
  });
  return res;
});

export const updateExpiringAdmissionStatus = createAsyncThunk(
  'crdMigration/updateExpiringAdmissionStatus',
  async (data) => {
    const res = await apiRequest({
      method: 'post',
      url: `analytics/updateExpiringAdmissionStatus`,
      data,
    });
    return res;
  },
);
export const updateNote = createAsyncThunk('crdMigration/updateNote', async (data) => {
  const res = await apiRequest({
    method: 'put',
    url: `analytics/addCroAccountsNotes`,
    data,
  });
  return res;
});

export const getNonScheduleVerification = createAsyncThunk(
  'crdMigration/getNonScheduleVerification',
  async (params) => {
    const res = await apiRequest({
      method: 'get',
      url: `analytics/attendance-verification/${params?.fromDate}/${params?.toDate}`,
    });
    return res;
  },
);

export const updateNonScheduleVerification = createAsyncThunk(
  'crdMigration/updateNonScheduleVerification',
  async (data) => {
    const res = await apiRequest({
      method: 'put',
      url: `analytics/verifySessionDetails`,
      data,
    });
    return res;
  },
);

export const getReportingUnderHead = createAsyncThunk('crdMigration/getReportingUnderHead', async (data) => {
  const res = await apiRequest({
    method: 'get',
    url: `general/reproting-under-head`,
  });
  return res;
});

// ===================----THUNKS----========================================

// ===================----SLICE----========================================

const crd_migration_slice = createSlice({
  name: 'crdMigration',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //*************  student session Analytics ***********
    builder.addCase(getStudentSessionAnalyticsTable.pending, (state) => {
      state.studentSessionAnalyticsTable.loading = true;
    });
    builder.addCase(getStudentSessionAnalyticsTable.fulfilled, (state, action) => {
      state.studentSessionAnalyticsTable.loading = false;
      state.studentSessionAnalyticsTable.data = action.payload?.data;
      state.studentSessionAnalyticsTable.meta = action.payload?.meta;
    });
    //****************************************************

    //********* Inactive Students Data Analytics *****
    builder.addCase(getInactiveStudentDataAnalytcsTable.pending, (state) => {
      state.inactiveStudentDataAnalytcsTable.loading = true;
    });
    builder.addCase(getInactiveStudentDataAnalytcsTable.fulfilled, (state, action) => {
      state.inactiveStudentDataAnalytcsTable.loading = false;
      state.inactiveStudentDataAnalytcsTable.data = action.payload?.data;
    });
    //****************************************************
    //************* student session Analytics ************

    //************* Tc Upoaded Student Details ************
    builder.addCase(getTCUploadStudentDetailsTable.pending, (state) => {
      state.tcUploadStudentDetailsTable.loading = true;
    });
    builder.addCase(getTCUploadStudentDetailsTable.fulfilled, (state, action) => {
      state.tcUploadStudentDetailsTable.loading = false;
      state.tcUploadStudentDetailsTable.data = action.payload?.data;
      state.tcUploadStudentDetailsTable.meta = action.payload?.meta;
    });
    //************* Tc Upoaded Student Details ************

    //************* Tp verification  ********************
    builder.addCase(getTpVerificationTable.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTpVerificationTable.fulfilled, (state, action) => {
      state.loading = false;
    });

    //************* Tp verification  ************************

    //************* Expiring Admissions  ************************

    builder.addCase(getExpiringAdmissionTable.pending, (state) => {
      state.expiringAdmissionTable.loading = true;
    });
    builder.addCase(getExpiringAdmissionTable.fulfilled, (state, action) => {
      state.expiringAdmissionTable.data = action.payload?.data;
      state.expiringAdmissionTable.meta = action.payload?.meta;
      state.expiringAdmissionTable.loading = false;
    });

    //************* Expiring Admissions  ************************

    //********* getCourseIncomeTable *****
    builder.addCase(getCourseIncomeTable.pending, (state) => {
      state.courseIncomeTable.loading = true;
    });
    builder.addCase(getCourseIncomeTable.fulfilled, (state, action) => {
      state.courseIncomeTable.loading = false;
      state.courseIncomeTable.data = action.payload?.data;
      state.courseIncomeTable.meta = action.payload?.meta;
    });
    //****************************************************

    //********* CroIndividualAccounts *****
    builder.addCase(getCroIndividualAccountsTable.pending, (state) => {
      state.croIndividualAccountsTable.loading = true;
    });
    builder.addCase(getCroIndividualAccountsTable.fulfilled, (state, action) => {
      state.croIndividualAccountsTable.loading = false;
      state.croIndividualAccountsTable.data = action.payload?.data;
      state.croIndividualAccountsTable.meta = action.payload?.meta;
    });
    //****************************************************

    //**********************Department Employees******************************
    builder.addCase(getDepartmentEmployeesTable.pending, (state) => {
      state.departmentEmployeesTable.loading = true;
    });
    builder.addCase(getDepartmentEmployeesTable.fulfilled, (state, action) => {
      state.departmentEmployeesTable.loading = false;
      state.departmentEmployeesTable.data = action.payload?.data;
      state.departmentEmployeesTable.meta = action.payload?.meta;
    });

    //********* Student Class Restart Date *****
    builder.addCase(getStudentClassRestartDateTable.pending, (state) => {
      state.studentClassRestartDateTable.loading = true;
    });
    builder.addCase(getStudentClassRestartDateTable.fulfilled, (state, action) => {
      state.studentClassRestartDateTable.loading = false;
      state.studentClassRestartDateTable.data = action.payload?.data;
      state.studentClassRestartDateTable.meta = action.payload?.meta;
    });
    //****************************************************

    //********* CRO Perfomance Analytics *****
    builder.addCase(getCroPerfomanceAnalytics.pending, (state) => {
      state.croPerfomanceAnalyticsTable.loading = true;
    });
    builder.addCase(getCroPerfomanceAnalytics.fulfilled, (state, action) => {
      state.croPerfomanceAnalyticsTable.data = action.payload?.data || [];
      state.croPerfomanceAnalyticsTable.loading = false;
    });
    //****************************************************

    //********* CRO Analytics *****
    builder.addCase(getCroAnalyticsTable.pending, (state) => {
      state.croAnalyticsTable.loading = true;
    });
    builder.addCase(getCroAnalyticsTable.fulfilled, (state, action) => {
      state.croAnalyticsTable.loading = false;
      state.croAnalyticsTable.data = action.payload?.data;
      state.croAnalyticsTable.meta = action.payload?.meta;
    });
    //****************************************************

    //********* Course Perfomance Analytics *****
    builder.addCase(getCoursePerfomanceAnalytics.pending, (state) => {
      state.coursePerfomanceAnalyticsTable.loading = true;
    });
    builder.addCase(getCoursePerfomanceAnalytics.fulfilled, (state, action) => {
      state.coursePerfomanceAnalyticsTable.loading = false;
      state.coursePerfomanceAnalyticsTable.data = action.payload?.analytics || [];
    });
    //****************************************************

    //********* get Payment Methods *****
    builder.addCase(getPaymentMethods.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getPaymentMethods.fulfilled, (state, action) => {
      state.loading = false;
      state.paymentMethods = action.payload?.data;
    });
    //****************************************************

    //********* Trainer MOU Details *****
    builder.addCase(getTrainerMOUTable.pending, (state) => {
      state.trainerMOUTable.loading = true;
    });
    builder.addCase(getTrainerMOUTable.fulfilled, (state, action) => {
      state.trainerMOUTable.loading = false;
      state.trainerMOUTable.data = action.payload?.data;
      state.trainerMOUTable.meta = action.payload?.meta;
    });
    //****************************************************
    //********* put trainer MOU Details *****
    builder.addCase(putTrainerMOUDetails.pending, (state) => {
      state.submitLoading = true;
    });
    builder.addCase(putTrainerMOUDetails.fulfilled, (state, action) => {
      state.submitLoading = false;
    });
    //****************************************************

    //********* get Trainer with Search *****
    builder.addCase(getTrainerWithSearch.pending, (state) => {
      state.allTrainers.loading = true;
    });
    builder.addCase(getTrainerWithSearch.fulfilled, (state, action) => {
      state.allTrainers.loading = false;
      state.allTrainers.data = action.payload?.data;
    });
    //****************************************************

    //********* post trainer MOU Details *****
    builder.addCase(postTrainerMOUDetails.pending, (state) => {
      state.submitLoading = true;
    });
    builder.addCase(postTrainerMOUDetails.fulfilled, (state, action) => {
      state.submitLoading = false;
    });
    //****************************************************
    //********* Daily attendance students *****
    builder.addCase(getDailyNoAttendanceStudents.pending, (state) => {
      state.dailyNoAttendanceStudentsTable.loading = true;
    });
    builder.addCase(getDailyNoAttendanceStudents.fulfilled, (state, action) => {
      state.dailyNoAttendanceStudentsTable.loading = false;
      state.dailyNoAttendanceStudentsTable.data = action.payload?.data;
      state.dailyNoAttendanceStudentsTable.meta = action.payload?.meta;
    });
    //****************************************************
    //********* emi payments *****
    builder.addCase(getEmiPayments.pending, (state) => {
      state.emiPaymentsTable.loading = true;
    });
    builder.addCase(getEmiPayments.fulfilled, (state, action) => {
      state.emiPaymentsTable.loading = false;
      state.emiPaymentsTable.data = action.payload?.data;
      state.emiPaymentsTable.meta = action.payload?.meta;
    });
    //****************************************************
    //********* tutor replacements *****
    builder.addCase(getTutorReplacements.pending, (state) => {
      state.tutorReplacementsTable.loading = true;
    });
    builder.addCase(getTutorReplacements.fulfilled, (state, action) => {
      state.tutorReplacementsTable.loading = false;
      state.tutorReplacementsTable.data = action.payload?.data;
      state.tutorReplacementsTable.meta = action.payload?.meta;
    });
    builder.addCase(getTutorReplacements.rejected, (state, action) => {
      // cancelled by a newer filter change, which is still loading and will fill the table
      if (action.meta?.aborted) return;
      state.tutorReplacementsTable.loading = false;
      state.tutorReplacementsTable.data = [];
      state.tutorReplacementsTable.meta = {};
    });
    //****************************************************
    //********* Monthly Accounts  *****
    builder.addCase(getMonthlyAccounts.pending, (state) => {
      state.monthlyAccounts.loading = true;
    });
    builder.addCase(getMonthlyAccounts.fulfilled, (state, action) => {
      state.monthlyAccounts.loading = false;
      state.monthlyAccounts.data = action.payload?.data;
      state.monthlyAccounts.summary = action.payload?.summary;
    });
    //****************************************************
    //********* Attendance View *****
    builder.addCase(getAttendanceView.pending, (state) => {
      state.attendanceViewTable.loading = true;
    });
    builder.addCase(getAttendanceView.fulfilled, (state, action) => {
      state.attendanceViewTable.loading = false;
      state.attendanceViewTable.data = action.payload?.data;
    });
    //****************************************************
    //********* Attendance signle View *****
    builder.addCase(fetchAttendanceData.pending, (state) => {
      state.attendanceSingleViewTable.loading = true;
    });
    builder.addCase(fetchAttendanceData.fulfilled, (state, action) => {
      state.attendanceSingleViewTable.loading = false;
      state.attendanceSingleViewTable.data = action.payload;
    });
    //****************************************************
    //********* Update expring Admission Status *****
    builder.addCase(updateExpiringAdmissionStatus.pending, (state) => {
      state.submitLoading = true;
    });
    builder.addCase(updateExpiringAdmissionStatus.fulfilled, (state, action) => {
      state.submitLoading = false;
    });
    //****************************************************
    //********* Update Note *****
    builder.addCase(updateNote.pending, (state) => {
      state.submitLoading = true;
    });
    builder.addCase(updateNote.fulfilled, (state, action) => {
      state.submitLoading = false;
    });
    //****************************************************
    //********* Non Schedule verifications *****
    builder.addCase(getNonScheduleVerification.pending, (state) => {
      state.nonScheduleVerificationTable.loading = true;
    });
    builder.addCase(getNonScheduleVerification.fulfilled, (state, action) => {
      state.nonScheduleVerificationTable.loading = false;
      state.nonScheduleVerificationTable.data = action.payload?.data;
    });
    //****************************************************
    //********* update Non Scheuld Verification *****
    builder.addCase(updateNonScheduleVerification.pending, (state) => {
      state.submitLoading = true;
    });
    builder.addCase(updateNonScheduleVerification.fulfilled, (state, action) => {
      state.submitLoading = false;
    });
    //****************************************************
    //********* get Reporting Under Head *****
    builder.addCase(getReportingUnderHead.pending, (state) => {
      state.reportingUnderHead.loading = true;
    });
    builder.addCase(getReportingUnderHead.fulfilled, (state, action) => {
      state.reportingUnderHead.loading = false;
      state.reportingUnderHead.data = action.payload?.data;
    });
    //****************************************************
  },
});

export const crdMigrationSlice = crd_migration_slice.reducer;
